import { get } from './clients/donors'

export const getDonorById = async id => {
  return await get(`/donors/${id}`)
}

export const getDonorExists = async id => {
  return await get(`/donors/${id}/exists`)
}
